import './Services.scss';

export default function Services() {
	return (
		<section className='services my-5' id='services'>
			<div className='container'>
				<div className='services-title'>
					<h2 className='display-3 text-center fw-bold'>Nuestros Servicios</h2>
					<p className='text-center lead'>
						Unidades en excelente estado, todas debidamente identificadas con branding
						empresarial y equipadas con equipos de rastreo satelital.
					</p>
				</div>
				<div className='row pt-5'>
					<div className='col-12 col-md-4'>
						<div className='card h-80 border-primary-color shadow-lg p-3 mb-5 rounded'>
							<div className='text-center pt-5'>
								<i className='bi bi-laptop style-icon-service'></i>
							</div>
							<div className='card-body'>
								<h5 className='card-title text-center h2 fw-bold'>
									Servicios de carga y media milla
								</h5>
								<p className='card-text text-center px-4 text-muted'>
									Especializados en operación y transporte de carga consolidada ”LTL”,
									unidad dedicada “FTL”
								</p>
								{/* <div className='text-center py-3'>
									<button type='button' className='btn  btn-lg rounded-pill bg-ligt-color'>
										Go somewhere
									</button>
								</div> */}
							</div>
						</div>
					</div>
					<div className='col-12 col-md-4'>
						<div className='card h-80 border-primary-color shadow-lg p-3 mb-5 rounded'>
							<div className='text-center pt-5'>
								<i className='bi bi-box-seam style-icon-service'></i>
							</div>
							<div className='card-body'>
								<h5 className='card-title text-center h2 fw-bold'>
									Servicios de primera, última milla y logística inversa
								</h5>
								<p className='card-text text-center px-4 text-muted'>
									Logística de punta a punta, gestionando las entregas a clientes finales,
									recolecciones con sellers o las devoluciones de productos.
								</p>
								{/* <div className='text-center py-3'>
									<button type='button' className='btn  btn-lg rounded-pill bg-ligt-color'>
										Go somewhere
									</button>
								</div> */}
							</div>
						</div>
					</div>
					<div className='col-12 col-md-4'>
						<div className='card h-80 border-primary-color shadow-lg p-3 mb-5 rounded'>
							<div className='text-center pt-5'>
								<i className='bi bi-truck style-icon-service'></i>
							</div>
							<div className='card-body'>
								<h5 className='card-title text-center h2 fw-bold'>
									Servicios dedicados de logística
								</h5>
								<p className='card-text text-center px-4 text-muted'>
									Envíos y servicios especializados de logística para empresas, consultoría
									e ingeniería de negocios.
								</p>
								{/* <div className='text-center py-3'>
									<button type='button' className='btn  btn-lg rounded-pill bg-ligt-color'>
										Go somewhere
									</button>
								</div> */}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
